import React, { useState, useEffect } from 'react';
import ItemSummaryCard from './ItemSummary'; // Assuming ItemSummary.js is in the same directory
import { API_BASE_URL} from '../urldata'


function Recentitems() {
  const [recentItems, setRecentItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecentItems = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_BASE_URL}/tapi/search?sort=created_at:desc`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        // Assuming the API returns an object with a 'results' array like the search component
        setRecentItems(data.results || []);
      } catch (err) {
        console.error("Failed to fetch recent items:", err);
        setError(err.message || "Failed to load recent items.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchRecentItems();
  }, []);

  if (isLoading) return <div className="text-center my-4"><p>Loading recent items...</p></div>;
  if (error) return <div className="alert alert-danger" role="alert">Error: {error}</div>;
  if (!recentItems || recentItems.length === 0) return <div className="text-center my-4"><p>No recent items to display.</p></div>;

  return (
    <div className="recent-items-container my-4">
      <h2 className="mb-3" >
        Recently Added
      </h2>
      <div className="row">
        {recentItems.map(item => (
          <div key={item.id} className="col-lg-3 col-md-6 mb-4 recent-item"> {/* 3 columns on large, 2 on medium, 1 on small screens */}
            <ItemSummaryCard item={item} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Recentitems;
